import { Component, ViewEncapsulation } from '@angular/core';

import { UiService } from '../../services/ui.service';

@Component({
  selector: 'hcf-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class FooterComponent {
  constructor(private _uiService: UiService) {}

  toggle(id) {
    this._uiService.toggleClass('#' + id, 'expanded');
    this._uiService.slideToggle('#' + id + ' + .toggle-panel');
  }
}
